<template>
    <div class="answers">
        <fieldset>
            <input
                :value="value"
                type="text"
                required=""
                autocomplete="off"
                @input="updateValue($event.target.value)"
            >
            <label>
                {{ label }}
            </label>
        </fieldset>
    </div>
</template>

<script>

export default {
    props: {
        label: {
            type: String,
            default: '',
        },
        value: {
            type: String,
            default: null,
        },
    },

    methods: {
        /**
         * Emits 'input' event
         *
         * @param {string} value Input value.
         */
        updateValue(value) {
            this.$emit('input', value);
        },
    },
};
</script>
